// Parallax
function setTranslate(el, y) {
	el.style.transform = `translate3d(0px, ${y}px, 0)`;
}

export default ({ element, container, factor = 0.2 }) => {
	let freeze = false;
	init();

	function scrollLoop() {
		setTranslate(element, (container == window ? window.scrollY : container.scrollTop) * factor);
		if (freeze) return;
		requestAnimationFrame(scrollLoop);
	}

	function init() {
		freeze = false;
		scrollLoop();
	}

	function stop() {
		freeze = true;
	}

	function destroy() {
		stop();
	}

	return {
		init,
		stop,
		destroy,
	};
};
